module Meevo.Plugins.ClientApp {
    "use strict";

    const MAXSAFEINTEGER = 2147483647;

    export class ViewBioConfigSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        public employeeCategories: any;
        public copy: any;
        public customButtonsSet: any;
        public auditNoun: Meevo.Model.NounEnum;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected basedataService: Meevo.Components.BaseClasses.IDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $rootScope: angular.IRootScopeService,
            protected $mdToast: angular.material.IToastService,
            protected $translate: angular.translate.ITranslateService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            sectionSecurityKey?: string,
            protected context?: Meevo.Plugins.ClientApp.ClientAppContext) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
            this.initializeData();
        }

        initializeData(): void {
            this.auditNoun = Meevo.Model.NounEnum.ClientAppViewBio;
            this.getEmployeeCategories();
            this.context.setMode(Model.MaintenanceFormState.Readonly);
            this.mode = Model.MaintenanceFormState.Readonly;

            var scope = this;
            this.customButtonsSet = [
                {
                    text: 'LABEL_EDIT',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppViewBioTab, Model.VerbEnum.EditButtonClicked, null, null);
                        scope.context.edit();
                        scope.takeBackup();
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => this.mode == Model.MaintenanceFormState.Readonly,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_VIEWBIOCONFIG + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
                {
                    text: 'LABEL_SAVE',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppViewBioTab, Model.VerbEnum.SaveButtonClicked, null, null);
                        scope.saveEmployeeCategories();
                        this.mode = Model.MaintenanceFormState.Readonly;
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => this.mode == Meevo.Model.MaintenanceFormState.Editing,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_VIEWBIOCONFIG + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
                {
                    text: 'LABEL_CANCEL',
                    clickHandler: () => {
                        this.basedataService.trackUsage(Meevo.Model.NounEnum.ClientAppViewBioTab, Model.VerbEnum.CancelButtonClicked, null, null);
                        this.employeeCategories = angular.copy(this.copy);
                        scope.context.setMode(Model.MaintenanceFormState.Readonly);
                        scope.mode = Model.MaintenanceFormState.Readonly;
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => this.mode == Meevo.Model.MaintenanceFormState.Editing,
                    securityRules: Meevo.Components.Common.SecurityKeys.INTEGRATION_CLIENTAPP_TAB_VIEWBIOCONFIG + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'right'
                },
            ];
        }

        getEmployeeCategories() {
            var criteria = {
                criteria: {
                    businessType: null,
                    coBusinessTypeId: null,
                    coFilterByLocationId: null,
                    coSearchResultFilter: 0,
                    coSearchType: 0,
                    includeActive: true,
                    includeDeleted: false,
                    includeInactive: false,
                    location: null,
                    maintenanceMode: true,
                },
                itemsPerPage: MAXSAFEINTEGER,
                pageNumber: 0,
                sortBy: null,
                sortDirection: 0
            };

            this.dataService.customMethodData("api/ClientApp/ViewBioConfig/List", "POST", criteria).then((data) => {
                if (data.data) {
                    this.employeeCategories = data.data;
                    this.copy = angular.copy(this.employeeCategories);
                }
            });

            //this.employeeCategories = new Meevo.Components.BaseClasses.PagedResults(this.basedataService, "ClientApp/ViewBioConfig", this.updateEmployeeCategoriesInfo, this);
            //this.employeeCategories.initSearch(criteria, null, criteria);
            //this.copy = angular.copy(this.employeeCategories.loadedPages);
        }

        updateEmployeeCategoriesInfo = (pageNumber, employeeCategories: any): void => {
            if (employeeCategories != null) {
                employeeCategories.forEach(category => {
                    for (var i = 0; i < category.employees.length; i++) {
                        if (category.employees[i] != null && category.employees[i].isEnabled) {
                            category.isEnabled = true;
                            break;
                        }
                    }
                });
            }
        };

        saveEmployeeCategories() {
            var employees = { employeeCategories: [] };

            for (var i = 0; i < this.employeeCategories.length; i++) {
                employees.employeeCategories.push(this.employeeCategories[i]);
            }

            this.dataService.customMethodData("api/ClientApp/ViewBioConfig", "POST", employees).then((data) => {
                this.getEmployeeCategories();
            });
        }

        public clickCategory(employeeCategories): void {
            if (this.mode == Model.MaintenanceFormState.Readonly)
                return;

            if (employeeCategories.isEnabled) {
                for (var i = 0; i < employeeCategories.employees.length; i++) {
                    employeeCategories.employees[i].isEnabled = true;
                }
            }
            else {
                for (var i = 0; i < employeeCategories.employees.length; i++) {
                    employeeCategories.employees[i].isEnabled = false;
                }
            }
        }

        public clickEmployee(employeeCategories, employeeIsEnabled): void {
            if (this.mode == Model.MaintenanceFormState.Readonly)
                return;

            if (employeeIsEnabled) {
                employeeCategories.isEnabled = true;
                return;
            }
            else if (!employeeIsEnabled) {
                for (var i = 0; i < employeeCategories.employees.length; i++) {
                    if (employeeCategories.employees[i].isEnabled) {
                        return;
                    }
                }
                employeeCategories.isEnabled = false;
            }
        }

        openEmployeeDefinition(employeeId: string): void {
            if (!employeeId) return;

            // Build params for loading Product Definition
            let stateParams = {
                id: employeeId,
                actionState: Meevo.Model.MaintenanceFormState.Readonly,
                targetState: Meevo.Model.MaintenanceFormVisualState.Detail
            };

            this.$rootScope.$broadcast("gotoState", {
                stateName: this.appSettings.ROUTE_NAMES.employee,
                stateParams: stateParams
            });
        }
    }
}